<div class="op-application-details-container">
  <div class="row">
    <div class="col">
      <div class="application-details">
        <h1
          class="title tt_norms500"
          (click)="isCollapsed = !isCollapsed"
          *ngIf="showTitle">
          {{ 'Application Summary' | translate }}
          <span>
            <img
              class="me-1"
              src="/assets/svg-icons/{{
                isCollapsed ? 'eye' : 'eye-slash'
              }}.svg"
              alt="" />
            {{
              isCollapsed
                ? ('View details' | translate)
                : ('Hide details' | translate)
            }}</span
          >
        </h1>
        <div [(ngbCollapse)]="isCollapsed" class="mt-4">
          <ng-container
            *ngFor="
              let data of applicationSummary;
              let index = index;
              trackBy: trackByFn
            ">
            <!-- Regular section or Service section header -->
            <h1 class="form-preview-header tt_norms500 mb-3">
              {{ index + 1 + '.' }} {{ data.formGroupName | translate }}
            </h1>

            <!-- Service sections handling -->
            <ng-container *ngIf="data.isService; else regularSection">
              <!-- Loop through service internal sections -->
              <ng-container
                *ngFor="
                  let serviceSection of data.nestedSections;
                  let serviceIndex = index
                ">
                <!-- Nested service section with same styling as regular sections -->
                <div class="ms-4">
                  <h1 class="form-preview-header tt_norms500 mb-3">
                    {{ serviceIndex + 1 }}.
                    {{
                      serviceSection.fieldGroupName.charAt(0).toUpperCase() +
                        serviceSection.fieldGroupName.slice(1).toLowerCase()
                        | translate
                    }}
                  </h1>
                  <irembogov-application-form-preview-card
                    *ngIf="!applicationOtp; else nestedNonLoggedInApplication"
                    [applicationId]="application?.applicationId"
                    [data]="{
                      formGroupName:
                        serviceSection.fieldGroupName || 'Unknown Section',
                      formGroupKey: serviceSection.fieldGroupKey || '',
                      formGroup: [serviceSection]
                    }"
                    [columnSize]="'col-md-6 mb-3'"
                    [applicationBaseUrl]="applicationBaseUrl"
                    [applicationPath]="applicationPath">
                  </irembogov-application-form-preview-card>
                  <ng-template #nestedNonLoggedInApplication>
                    <irembogov-non-loggedin-application-form-preview-card
                      [data]="{
                        formGroupName:
                          serviceSection.fieldGroupName || 'Unknown Section',
                        formGroupKey: serviceSection.fieldGroupKey || '',
                        formGroup: [serviceSection]
                      }"
                      [columnSize]="'col-md-6 mb-3'"
                      [applicationBaseUrl]="applicationBaseUrl"
                      [applicationPath]="nonLoggedInapplicationPath"
                      [applicationNumber]="application?.applicationNumber"
                      [otp]="applicationOtp">
                    </irembogov-non-loggedin-application-form-preview-card>
                  </ng-template>
                </div>
              </ng-container>
            </ng-container>

            <!-- Regular section template -->
            <ng-template #regularSection>
              <irembogov-application-form-preview-card
                *ngIf="!applicationOtp; else nonLoggedInApplication"
                [applicationId]="application?.applicationId"
                [data]="data"
                [columnSize]="'col-md-6 mb-3'"
                [applicationBaseUrl]="applicationBaseUrl"
                [applicationPath]="applicationPath">
              </irembogov-application-form-preview-card>
              <ng-template #nonLoggedInApplication>
                <irembogov-non-loggedin-application-form-preview-card
                  [data]="data"
                  [columnSize]="'col-md-6 mb-3'"
                  [applicationBaseUrl]="applicationBaseUrl"
                  [applicationPath]="nonLoggedInapplicationPath"
                  [applicationNumber]="application?.applicationNumber"
                  [otp]="applicationOtp">
                </irembogov-non-loggedin-application-form-preview-card>
              </ng-template>
            </ng-template>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
